(ns common.widgets.overlay-page
  (:require ["@mui/material/AppBar$default" :as Appbar]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Skeleton$default" :as Skeleton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Toolbar$default" :as Toolbar]
            ["@mui/material/Typography$default" :as Typography]
            ["react-use/lib/useKey$default" :as useKey]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.resource.query.campaign :as campaign-queries]
            [common.util :refer [spread-obj]]
            [common.widgets.page :refer [wpp-os-content-padding-sx]]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui overlay-page [{:keys [ref style children]}]
  ($ Box
     {:ref ref
      :style style
      :sx (fn [^js theme]
            #js {:zIndex (.. theme -zIndex -mobileStepper)
                 :position "absolute"
                 :inset 0
                 :backgroundColor "background.paper"
                 :color "text.primary"
                 :display "flex"
                 :flexDirection "column"})}
     children))

(defui entity-chip []
  (let [{:keys [adset-id campaign-id]} (use-subscribe [:url-context])
        {campaign-is-fetching :isFetching campaign :data} (use-query (campaign-queries/campaign-query {:campaign-id campaign-id}))
        {adset-is-fetching :isFetching adset :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))]
    (when (or adset adset-is-fetching
              campaign campaign-is-fetching)
      ($ Chip
         {:label (cond
                   (or adset adset-is-fetching) (or (:name adset)
                                                    ($ Skeleton
                                                       {:width "10rem"}))
                   (or campaign campaign-is-fetching) (or (:name campaign)
                                                          ($ Skeleton
                                                             {:width "10rem"}))
                   :else "")}))))

(defui header [{:keys [title children on-close entity-name]}]
  (let [os-enabled? (use-subscribe [:common.os/enabled])]
    (useKey "Escape" (or on-close (fn [])))
    ($ Appbar
       {:sx #js {;; Override sticky position
                 :position "relative"
                 :backgroundColor "background.paper"
                 :backgroundImage "none"
                 :boxShadow "none"
                 :borderBottomStyle "solid"
                 :borderBottomWidth "1px"
                 :borderBottomColor "divider"
                 :color "inherit"
                 :borderRadius 0}}
       ($ Toolbar
          {:sx (spread-obj
                #js {"@media (min-width: 600px)" #js {:minHeight "56px"}}
                (when os-enabled?
                  #js {"@media (min-width: 1200px)" wpp-os-content-padding-sx}))}
          ($ Stack
             {:direction "row"
              :gap 1
              :justifyContent "space-between"
              :flex 1}
             ($ Stack
                {:direction "row"
                 :gap 1
                 :alignItems "center"}
                (when (some? on-close)
                  ($ IconButton
                     {:onClick on-close
                      :data-testid "close-overlay-button"}
                     ($ Icon "chevron_left")))
                ($ Typography {:variant "h3"} title)
                (if entity-name
                  ($ Chip {:label entity-name})
                  ($ entity-chip)))
             children)))))
